import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const ZoomIn = ({
  width = 21,
  height = 22,
  className,
  color,
  decorative = true,
  ariaLabel = "Zoom in",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 21 22"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        d="M19.8 11.272h-9v9.416H9.6v-9.416h-9v-1.256h9V.6h1.2v9.416h9z"
      />
    </svg>
  );
};
